import { gql } from "@apollo/client";

export const UPDATE_DEFAULT_WORKER_POOL_RUNNER_IMAGES = gql`
  mutation UpdateDefaultPublicWorkerPoolRunnerImage(
    $privateWorkerPoolRunnerImage: String!
    $publicWorkerPoolRunnerImage: String!
  ) {
    accountUpdateDefaultWorkerPoolRunnerImages(
      privateWorkerPoolRunnerImage: $privateWorkerPoolRunnerImage
      publicWorkerPoolRunnerImage: $publicWorkerPoolRunnerImage
    ) {
      privateWorkerPoolRunnerImage
      publicWorkerPoolRunnerImage
    }
  }
`;

export const GET_ACCOUNT_DEFAULT_RUNNER_IMAGES = gql`
  query GetAccountDefaultRunnerImages {
    defaultPublicWorkerPoolRunnerImage
    defaultPrivateWorkerPoolRunnerImage
  }
`;
